/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppClusterRouteImport } from './routes/_app/cluster'
import { Route as AppFilesRouteImport } from './routes/_app/files'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppAccessServiceAccountsRouteImport } from './routes/_app/access/service-accounts'
import { Route as AppBucketsIndexRouteImport } from './routes/_app/buckets/index'
import { Route as AppBucketsBucketRouteImport } from './routes/_app/buckets/$bucket'
import { Route as AppCollectionsIndexRouteImport } from './routes/_app/collections/index'
import { Route as AppCollectionsNameRouteImport } from './routes/_app/collections/$name'
import { Route as AppErasureCodingIndexRouteImport } from './routes/_app/erasure-coding/index'
import { Route as AppErasureCodingVolumeIdRouteImport } from './routes/_app/erasure-coding/$volumeId'
import { Route as AppMaintenanceIndexRouteImport } from './routes/_app/maintenance/index'
import { Route as AppMaintenanceJobTypeRouteImport } from './routes/_app/maintenance/$jobType'
import { Route as AppMessagingIndexRouteImport } from './routes/_app/messaging/index'
import { Route as AppTablesIndexRouteImport } from './routes/_app/tables/index'
import { Route as AppVolumesIndexRouteImport } from './routes/_app/volumes/index'
import { Route as AppVolumesVolumeIdRouteImport } from './routes/_app/volumes/$volumeId'
import { Route as AppAccessGroupsIndexRouteImport } from './routes/_app/access/groups/index'
import { Route as AppAccessGroupsNameRouteImport } from './routes/_app/access/groups/$name'
import { Route as AppAccessPoliciesIndexRouteImport } from './routes/_app/access/policies/index'
import { Route as AppAccessPoliciesNameRouteImport } from './routes/_app/access/policies/$name'
import { Route as AppAccessPoliciesNewRouteImport } from './routes/_app/access/policies/new'
import { Route as AppAccessUsersIndexRouteImport } from './routes/_app/access/users/index'
import { Route as AppAccessUsersUsernameRouteImport } from './routes/_app/access/users/$username'
import { Route as AppMaintenanceJobsIndexRouteImport } from './routes/_app/maintenance/jobs.index'
import { Route as AppMaintenanceJobsJobIdRouteImport } from './routes/_app/maintenance/jobs.$jobId'
import { Route as AppMessagingNamespaceTopicRouteImport } from './routes/_app/messaging/$namespace.$topic'
import { Route as AppTablesBucketIndexRouteImport } from './routes/_app/tables/$bucket/index'
import { Route as AppTablesBucketNamespaceTableRouteImport } from './routes/_app/tables/$bucket/$namespace.$table'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppClusterRoute = AppClusterRouteImport.update({
  id: '/cluster',
  path: '/cluster',
  getParentRoute: () => AppRoute,
} as any)
const AppFilesRoute = AppFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppAccessServiceAccountsRoute =
  AppAccessServiceAccountsRouteImport.update({
    id: '/access/service-accounts',
    path: '/access/service-accounts',
    getParentRoute: () => AppRoute,
  } as any)
const AppBucketsIndexRoute = AppBucketsIndexRouteImport.update({
  id: '/buckets/',
  path: '/buckets/',
  getParentRoute: () => AppRoute,
} as any)
const AppBucketsBucketRoute = AppBucketsBucketRouteImport.update({
  id: '/buckets/$bucket',
  path: '/buckets/$bucket',
  getParentRoute: () => AppRoute,
} as any)
const AppCollectionsIndexRoute = AppCollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => AppRoute,
} as any)
const AppCollectionsNameRoute = AppCollectionsNameRouteImport.update({
  id: '/collections/$name',
  path: '/collections/$name',
  getParentRoute: () => AppRoute,
} as any)
const AppErasureCodingIndexRoute = AppErasureCodingIndexRouteImport.update({
  id: '/erasure-coding/',
  path: '/erasure-coding/',
  getParentRoute: () => AppRoute,
} as any)
const AppErasureCodingVolumeIdRoute =
  AppErasureCodingVolumeIdRouteImport.update({
    id: '/erasure-coding/$volumeId',
    path: '/erasure-coding/$volumeId',
    getParentRoute: () => AppRoute,
  } as any)
const AppMaintenanceIndexRoute = AppMaintenanceIndexRouteImport.update({
  id: '/maintenance/',
  path: '/maintenance/',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceJobTypeRoute = AppMaintenanceJobTypeRouteImport.update({
  id: '/maintenance/$jobType',
  path: '/maintenance/$jobType',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagingIndexRoute = AppMessagingIndexRouteImport.update({
  id: '/messaging/',
  path: '/messaging/',
  getParentRoute: () => AppRoute,
} as any)
const AppTablesIndexRoute = AppTablesIndexRouteImport.update({
  id: '/tables/',
  path: '/tables/',
  getParentRoute: () => AppRoute,
} as any)
const AppVolumesIndexRoute = AppVolumesIndexRouteImport.update({
  id: '/volumes/',
  path: '/volumes/',
  getParentRoute: () => AppRoute,
} as any)
const AppVolumesVolumeIdRoute = AppVolumesVolumeIdRouteImport.update({
  id: '/volumes/$volumeId',
  path: '/volumes/$volumeId',
  getParentRoute: () => AppRoute,
} as any)
const AppAccessGroupsIndexRoute = AppAccessGroupsIndexRouteImport.update({
  id: '/access/groups/',
  path: '/access/groups/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccessGroupsNameRoute = AppAccessGroupsNameRouteImport.update({
  id: '/access/groups/$name',
  path: '/access/groups/$name',
  getParentRoute: () => AppRoute,
} as any)
const AppAccessPoliciesIndexRoute = AppAccessPoliciesIndexRouteImport.update({
  id: '/access/policies/',
  path: '/access/policies/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccessPoliciesNameRoute = AppAccessPoliciesNameRouteImport.update({
  id: '/access/policies/$name',
  path: '/access/policies/$name',
  getParentRoute: () => AppRoute,
} as any)
const AppAccessPoliciesNewRoute = AppAccessPoliciesNewRouteImport.update({
  id: '/access/policies/new',
  path: '/access/policies/new',
  getParentRoute: () => AppRoute,
} as any)
const AppAccessUsersIndexRoute = AppAccessUsersIndexRouteImport.update({
  id: '/access/users/',
  path: '/access/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccessUsersUsernameRoute = AppAccessUsersUsernameRouteImport.update({
  id: '/access/users/$username',
  path: '/access/users/$username',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceJobsIndexRoute = AppMaintenanceJobsIndexRouteImport.update({
  id: '/maintenance/jobs/',
  path: '/maintenance/jobs/',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceJobsJobIdRoute = AppMaintenanceJobsJobIdRouteImport.update({
  id: '/maintenance/jobs/$jobId',
  path: '/maintenance/jobs/$jobId',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagingNamespaceTopicRoute =
  AppMessagingNamespaceTopicRouteImport.update({
    id: '/messaging/$namespace/$topic',
    path: '/messaging/$namespace/$topic',
    getParentRoute: () => AppRoute,
  } as any)
const AppTablesBucketIndexRoute = AppTablesBucketIndexRouteImport.update({
  id: '/tables/$bucket/',
  path: '/tables/$bucket/',
  getParentRoute: () => AppRoute,
} as any)
const AppTablesBucketNamespaceTableRoute =
  AppTablesBucketNamespaceTableRouteImport.update({
    id: '/tables/$bucket/$namespace/$table',
    path: '/tables/$bucket/$namespace/$table',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/cluster': typeof AppClusterRoute
  '/files': typeof AppFilesRoute
  '/settings': typeof AppSettingsRoute
  '/access/service-accounts': typeof AppAccessServiceAccountsRoute
  '/buckets/$bucket': typeof AppBucketsBucketRoute
  '/collections/$name': typeof AppCollectionsNameRoute
  '/erasure-coding/$volumeId': typeof AppErasureCodingVolumeIdRoute
  '/maintenance/$jobType': typeof AppMaintenanceJobTypeRoute
  '/volumes/$volumeId': typeof AppVolumesVolumeIdRoute
  '/buckets/': typeof AppBucketsIndexRoute
  '/collections/': typeof AppCollectionsIndexRoute
  '/erasure-coding/': typeof AppErasureCodingIndexRoute
  '/maintenance/': typeof AppMaintenanceIndexRoute
  '/messaging/': typeof AppMessagingIndexRoute
  '/tables/': typeof AppTablesIndexRoute
  '/volumes/': typeof AppVolumesIndexRoute
  '/access/groups/$name': typeof AppAccessGroupsNameRoute
  '/access/policies/$name': typeof AppAccessPoliciesNameRoute
  '/access/policies/new': typeof AppAccessPoliciesNewRoute
  '/access/users/$username': typeof AppAccessUsersUsernameRoute
  '/maintenance/jobs/$jobId': typeof AppMaintenanceJobsJobIdRoute
  '/messaging/$namespace/$topic': typeof AppMessagingNamespaceTopicRoute
  '/access/groups/': typeof AppAccessGroupsIndexRoute
  '/access/policies/': typeof AppAccessPoliciesIndexRoute
  '/access/users/': typeof AppAccessUsersIndexRoute
  '/maintenance/jobs/': typeof AppMaintenanceJobsIndexRoute
  '/tables/$bucket/': typeof AppTablesBucketIndexRoute
  '/tables/$bucket/$namespace/$table': typeof AppTablesBucketNamespaceTableRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/cluster': typeof AppClusterRoute
  '/files': typeof AppFilesRoute
  '/settings': typeof AppSettingsRoute
  '/': typeof AppIndexRoute
  '/access/service-accounts': typeof AppAccessServiceAccountsRoute
  '/buckets/$bucket': typeof AppBucketsBucketRoute
  '/collections/$name': typeof AppCollectionsNameRoute
  '/erasure-coding/$volumeId': typeof AppErasureCodingVolumeIdRoute
  '/maintenance/$jobType': typeof AppMaintenanceJobTypeRoute
  '/volumes/$volumeId': typeof AppVolumesVolumeIdRoute
  '/buckets': typeof AppBucketsIndexRoute
  '/collections': typeof AppCollectionsIndexRoute
  '/erasure-coding': typeof AppErasureCodingIndexRoute
  '/maintenance': typeof AppMaintenanceIndexRoute
  '/messaging': typeof AppMessagingIndexRoute
  '/tables': typeof AppTablesIndexRoute
  '/volumes': typeof AppVolumesIndexRoute
  '/access/groups/$name': typeof AppAccessGroupsNameRoute
  '/access/policies/$name': typeof AppAccessPoliciesNameRoute
  '/access/policies/new': typeof AppAccessPoliciesNewRoute
  '/access/users/$username': typeof AppAccessUsersUsernameRoute
  '/maintenance/jobs/$jobId': typeof AppMaintenanceJobsJobIdRoute
  '/messaging/$namespace/$topic': typeof AppMessagingNamespaceTopicRoute
  '/access/groups': typeof AppAccessGroupsIndexRoute
  '/access/policies': typeof AppAccessPoliciesIndexRoute
  '/access/users': typeof AppAccessUsersIndexRoute
  '/maintenance/jobs': typeof AppMaintenanceJobsIndexRoute
  '/tables/$bucket': typeof AppTablesBucketIndexRoute
  '/tables/$bucket/$namespace/$table': typeof AppTablesBucketNamespaceTableRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/cluster': typeof AppClusterRoute
  '/_app/files': typeof AppFilesRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/access/service-accounts': typeof AppAccessServiceAccountsRoute
  '/_app/buckets/$bucket': typeof AppBucketsBucketRoute
  '/_app/collections/$name': typeof AppCollectionsNameRoute
  '/_app/erasure-coding/$volumeId': typeof AppErasureCodingVolumeIdRoute
  '/_app/maintenance/$jobType': typeof AppMaintenanceJobTypeRoute
  '/_app/volumes/$volumeId': typeof AppVolumesVolumeIdRoute
  '/_app/buckets/': typeof AppBucketsIndexRoute
  '/_app/collections/': typeof AppCollectionsIndexRoute
  '/_app/erasure-coding/': typeof AppErasureCodingIndexRoute
  '/_app/maintenance/': typeof AppMaintenanceIndexRoute
  '/_app/messaging/': typeof AppMessagingIndexRoute
  '/_app/tables/': typeof AppTablesIndexRoute
  '/_app/volumes/': typeof AppVolumesIndexRoute
  '/_app/access/groups/$name': typeof AppAccessGroupsNameRoute
  '/_app/access/policies/$name': typeof AppAccessPoliciesNameRoute
  '/_app/access/policies/new': typeof AppAccessPoliciesNewRoute
  '/_app/access/users/$username': typeof AppAccessUsersUsernameRoute
  '/_app/maintenance/jobs/$jobId': typeof AppMaintenanceJobsJobIdRoute
  '/_app/messaging/$namespace/$topic': typeof AppMessagingNamespaceTopicRoute
  '/_app/access/groups/': typeof AppAccessGroupsIndexRoute
  '/_app/access/policies/': typeof AppAccessPoliciesIndexRoute
  '/_app/access/users/': typeof AppAccessUsersIndexRoute
  '/_app/maintenance/jobs/': typeof AppMaintenanceJobsIndexRoute
  '/_app/tables/$bucket/': typeof AppTablesBucketIndexRoute
  '/_app/tables/$bucket/$namespace/$table': typeof AppTablesBucketNamespaceTableRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/cluster'
    | '/files'
    | '/settings'
    | '/access/service-accounts'
    | '/buckets/$bucket'
    | '/collections/$name'
    | '/erasure-coding/$volumeId'
    | '/maintenance/$jobType'
    | '/volumes/$volumeId'
    | '/buckets/'
    | '/collections/'
    | '/erasure-coding/'
    | '/maintenance/'
    | '/messaging/'
    | '/tables/'
    | '/volumes/'
    | '/access/groups/$name'
    | '/access/policies/$name'
    | '/access/policies/new'
    | '/access/users/$username'
    | '/maintenance/jobs/$jobId'
    | '/messaging/$namespace/$topic'
    | '/access/groups/'
    | '/access/policies/'
    | '/access/users/'
    | '/maintenance/jobs/'
    | '/tables/$bucket/'
    | '/tables/$bucket/$namespace/$table'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/cluster'
    | '/files'
    | '/settings'
    | '/'
    | '/access/service-accounts'
    | '/buckets/$bucket'
    | '/collections/$name'
    | '/erasure-coding/$volumeId'
    | '/maintenance/$jobType'
    | '/volumes/$volumeId'
    | '/buckets'
    | '/collections'
    | '/erasure-coding'
    | '/maintenance'
    | '/messaging'
    | '/tables'
    | '/volumes'
    | '/access/groups/$name'
    | '/access/policies/$name'
    | '/access/policies/new'
    | '/access/users/$username'
    | '/maintenance/jobs/$jobId'
    | '/messaging/$namespace/$topic'
    | '/access/groups'
    | '/access/policies'
    | '/access/users'
    | '/maintenance/jobs'
    | '/tables/$bucket'
    | '/tables/$bucket/$namespace/$table'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/cluster'
    | '/_app/files'
    | '/_app/settings'
    | '/_app/'
    | '/_app/access/service-accounts'
    | '/_app/buckets/$bucket'
    | '/_app/collections/$name'
    | '/_app/erasure-coding/$volumeId'
    | '/_app/maintenance/$jobType'
    | '/_app/volumes/$volumeId'
    | '/_app/buckets/'
    | '/_app/collections/'
    | '/_app/erasure-coding/'
    | '/_app/maintenance/'
    | '/_app/messaging/'
    | '/_app/tables/'
    | '/_app/volumes/'
    | '/_app/access/groups/$name'
    | '/_app/access/policies/$name'
    | '/_app/access/policies/new'
    | '/_app/access/users/$username'
    | '/_app/maintenance/jobs/$jobId'
    | '/_app/messaging/$namespace/$topic'
    | '/_app/access/groups/'
    | '/_app/access/policies/'
    | '/_app/access/users/'
    | '/_app/maintenance/jobs/'
    | '/_app/tables/$bucket/'
    | '/_app/tables/$bucket/$namespace/$table'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cluster': {
      id: '/_app/cluster'
      path: '/cluster'
      fullPath: '/cluster'
      preLoaderRoute: typeof AppClusterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/files': {
      id: '/_app/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof AppFilesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/access/service-accounts': {
      id: '/_app/access/service-accounts'
      path: '/access/service-accounts'
      fullPath: '/access/service-accounts'
      preLoaderRoute: typeof AppAccessServiceAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/buckets/': {
      id: '/_app/buckets/'
      path: '/buckets'
      fullPath: '/buckets/'
      preLoaderRoute: typeof AppBucketsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/buckets/$bucket': {
      id: '/_app/buckets/$bucket'
      path: '/buckets/$bucket'
      fullPath: '/buckets/$bucket'
      preLoaderRoute: typeof AppBucketsBucketRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/collections/': {
      id: '/_app/collections/'
      path: '/collections'
      fullPath: '/collections/'
      preLoaderRoute: typeof AppCollectionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/collections/$name': {
      id: '/_app/collections/$name'
      path: '/collections/$name'
      fullPath: '/collections/$name'
      preLoaderRoute: typeof AppCollectionsNameRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/erasure-coding/': {
      id: '/_app/erasure-coding/'
      path: '/erasure-coding'
      fullPath: '/erasure-coding/'
      preLoaderRoute: typeof AppErasureCodingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/erasure-coding/$volumeId': {
      id: '/_app/erasure-coding/$volumeId'
      path: '/erasure-coding/$volumeId'
      fullPath: '/erasure-coding/$volumeId'
      preLoaderRoute: typeof AppErasureCodingVolumeIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance/': {
      id: '/_app/maintenance/'
      path: '/maintenance'
      fullPath: '/maintenance/'
      preLoaderRoute: typeof AppMaintenanceIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance/$jobType': {
      id: '/_app/maintenance/$jobType'
      path: '/maintenance/$jobType'
      fullPath: '/maintenance/$jobType'
      preLoaderRoute: typeof AppMaintenanceJobTypeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messaging/': {
      id: '/_app/messaging/'
      path: '/messaging'
      fullPath: '/messaging/'
      preLoaderRoute: typeof AppMessagingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tables/': {
      id: '/_app/tables/'
      path: '/tables'
      fullPath: '/tables/'
      preLoaderRoute: typeof AppTablesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/volumes/': {
      id: '/_app/volumes/'
      path: '/volumes'
      fullPath: '/volumes/'
      preLoaderRoute: typeof AppVolumesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/volumes/$volumeId': {
      id: '/_app/volumes/$volumeId'
      path: '/volumes/$volumeId'
      fullPath: '/volumes/$volumeId'
      preLoaderRoute: typeof AppVolumesVolumeIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/access/groups/': {
      id: '/_app/access/groups/'
      path: '/access/groups'
      fullPath: '/access/groups/'
      preLoaderRoute: typeof AppAccessGroupsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/access/groups/$name': {
      id: '/_app/access/groups/$name'
      path: '/access/groups/$name'
      fullPath: '/access/groups/$name'
      preLoaderRoute: typeof AppAccessGroupsNameRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/access/policies/': {
      id: '/_app/access/policies/'
      path: '/access/policies'
      fullPath: '/access/policies/'
      preLoaderRoute: typeof AppAccessPoliciesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/access/policies/$name': {
      id: '/_app/access/policies/$name'
      path: '/access/policies/$name'
      fullPath: '/access/policies/$name'
      preLoaderRoute: typeof AppAccessPoliciesNameRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/access/policies/new': {
      id: '/_app/access/policies/new'
      path: '/access/policies/new'
      fullPath: '/access/policies/new'
      preLoaderRoute: typeof AppAccessPoliciesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/access/users/': {
      id: '/_app/access/users/'
      path: '/access/users'
      fullPath: '/access/users/'
      preLoaderRoute: typeof AppAccessUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/access/users/$username': {
      id: '/_app/access/users/$username'
      path: '/access/users/$username'
      fullPath: '/access/users/$username'
      preLoaderRoute: typeof AppAccessUsersUsernameRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance/jobs/': {
      id: '/_app/maintenance/jobs/'
      path: '/maintenance/jobs'
      fullPath: '/maintenance/jobs/'
      preLoaderRoute: typeof AppMaintenanceJobsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance/jobs/$jobId': {
      id: '/_app/maintenance/jobs/$jobId'
      path: '/maintenance/jobs/$jobId'
      fullPath: '/maintenance/jobs/$jobId'
      preLoaderRoute: typeof AppMaintenanceJobsJobIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messaging/$namespace/$topic': {
      id: '/_app/messaging/$namespace/$topic'
      path: '/messaging/$namespace/$topic'
      fullPath: '/messaging/$namespace/$topic'
      preLoaderRoute: typeof AppMessagingNamespaceTopicRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tables/$bucket/': {
      id: '/_app/tables/$bucket/'
      path: '/tables/$bucket'
      fullPath: '/tables/$bucket/'
      preLoaderRoute: typeof AppTablesBucketIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tables/$bucket/$namespace/$table': {
      id: '/_app/tables/$bucket/$namespace/$table'
      path: '/tables/$bucket/$namespace/$table'
      fullPath: '/tables/$bucket/$namespace/$table'
      preLoaderRoute: typeof AppTablesBucketNamespaceTableRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppClusterRoute: typeof AppClusterRoute
  AppFilesRoute: typeof AppFilesRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccessServiceAccountsRoute: typeof AppAccessServiceAccountsRoute
  AppBucketsBucketRoute: typeof AppBucketsBucketRoute
  AppCollectionsNameRoute: typeof AppCollectionsNameRoute
  AppErasureCodingVolumeIdRoute: typeof AppErasureCodingVolumeIdRoute
  AppMaintenanceJobTypeRoute: typeof AppMaintenanceJobTypeRoute
  AppVolumesVolumeIdRoute: typeof AppVolumesVolumeIdRoute
  AppBucketsIndexRoute: typeof AppBucketsIndexRoute
  AppCollectionsIndexRoute: typeof AppCollectionsIndexRoute
  AppErasureCodingIndexRoute: typeof AppErasureCodingIndexRoute
  AppMaintenanceIndexRoute: typeof AppMaintenanceIndexRoute
  AppMessagingIndexRoute: typeof AppMessagingIndexRoute
  AppTablesIndexRoute: typeof AppTablesIndexRoute
  AppVolumesIndexRoute: typeof AppVolumesIndexRoute
  AppAccessGroupsNameRoute: typeof AppAccessGroupsNameRoute
  AppAccessPoliciesNameRoute: typeof AppAccessPoliciesNameRoute
  AppAccessPoliciesNewRoute: typeof AppAccessPoliciesNewRoute
  AppAccessUsersUsernameRoute: typeof AppAccessUsersUsernameRoute
  AppMaintenanceJobsJobIdRoute: typeof AppMaintenanceJobsJobIdRoute
  AppMessagingNamespaceTopicRoute: typeof AppMessagingNamespaceTopicRoute
  AppAccessGroupsIndexRoute: typeof AppAccessGroupsIndexRoute
  AppAccessPoliciesIndexRoute: typeof AppAccessPoliciesIndexRoute
  AppAccessUsersIndexRoute: typeof AppAccessUsersIndexRoute
  AppMaintenanceJobsIndexRoute: typeof AppMaintenanceJobsIndexRoute
  AppTablesBucketIndexRoute: typeof AppTablesBucketIndexRoute
  AppTablesBucketNamespaceTableRoute: typeof AppTablesBucketNamespaceTableRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppClusterRoute: AppClusterRoute,
  AppFilesRoute: AppFilesRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccessServiceAccountsRoute: AppAccessServiceAccountsRoute,
  AppBucketsBucketRoute: AppBucketsBucketRoute,
  AppCollectionsNameRoute: AppCollectionsNameRoute,
  AppErasureCodingVolumeIdRoute: AppErasureCodingVolumeIdRoute,
  AppMaintenanceJobTypeRoute: AppMaintenanceJobTypeRoute,
  AppVolumesVolumeIdRoute: AppVolumesVolumeIdRoute,
  AppBucketsIndexRoute: AppBucketsIndexRoute,
  AppCollectionsIndexRoute: AppCollectionsIndexRoute,
  AppErasureCodingIndexRoute: AppErasureCodingIndexRoute,
  AppMaintenanceIndexRoute: AppMaintenanceIndexRoute,
  AppMessagingIndexRoute: AppMessagingIndexRoute,
  AppTablesIndexRoute: AppTablesIndexRoute,
  AppVolumesIndexRoute: AppVolumesIndexRoute,
  AppAccessGroupsNameRoute: AppAccessGroupsNameRoute,
  AppAccessPoliciesNameRoute: AppAccessPoliciesNameRoute,
  AppAccessPoliciesNewRoute: AppAccessPoliciesNewRoute,
  AppAccessUsersUsernameRoute: AppAccessUsersUsernameRoute,
  AppMaintenanceJobsJobIdRoute: AppMaintenanceJobsJobIdRoute,
  AppMessagingNamespaceTopicRoute: AppMessagingNamespaceTopicRoute,
  AppAccessGroupsIndexRoute: AppAccessGroupsIndexRoute,
  AppAccessPoliciesIndexRoute: AppAccessPoliciesIndexRoute,
  AppAccessUsersIndexRoute: AppAccessUsersIndexRoute,
  AppMaintenanceJobsIndexRoute: AppMaintenanceJobsIndexRoute,
  AppTablesBucketIndexRoute: AppTablesBucketIndexRoute,
  AppTablesBucketNamespaceTableRoute: AppTablesBucketNamespaceTableRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
